<template>
    <div>
        <v-row>
            <v-col cols="6">
                <h1 class="headline font-weight-light mb-3">
                    <router-link class="link-a" :to="'/'"> DOCNONHP</router-link>
                     / PRINT
                </h1>
                <!-- <h1 class="headline font-weight-light mb-3">
                    <router-link class="link-a" :to="'/'"> Test</router-link>
                    / PRINT
                </h1> -->
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="6" class="text-right">
                <v-btn rounded small @click="print()">
                    <v-icon class="mr-1" dark small>mdi-printer</v-icon>
                    Print</v-btn
                >
            </v-col>
        </v-row>
        <div id="printDiv">
            <!-- ที่เขียน inline เพราะ css ไม่ยอมทำงานตอนปริ้น -->
            <div align="center" class="style2">
                <br />
                <br /><!-- 
        <div align="right">
            <span style="font-size: 15px;font-weight:bold;">เลขที่เอกสาร DOC20060355</span>
            <input type="hidden" id="no_doc" name="no_doc" value="DOC20060355">
            <input type="hidden" id="id_no_doc" name="id_no_doc" value="1">
        </div>
        <br> -->
                <div id="top">
                    <v-row>
                        <v-col align="left" cols="4">
                            <span>ส่วนที่ 1 ใบงานการบำรุงรักษา</span></v-col
                        >
                        <v-col cols="4"></v-col>
                        <v-col align="right" cols="4">
                            <span>ลำดับที่......................</span><br />
                            (สรุปรายงานประจำเดือน)</v-col
                        >
                    </v-row>
                    <v-row
                        ><img
                            style="
                                text-align: right;
                                width: 500px;
                                height: 75px;
                            "
                            src="../../../assets/nonhp/thaipost_logo.jpg"
                    /></v-row>
                    <v-row class="mt-4">
                        <v-col cols="3"></v-col>
                        <v-col cols="3">วันที่</v-col>
                        <v-col cols="1" style="margin-left: -100px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: 19px;
                                    margin-left: -30px;
                                "
                            ></div>
                        </v-col>
                        <v-col cols="3" style="margin-left: -128px"
                            >เดือน</v-col
                        >
                        <v-col cols="1" style="margin-left: -100px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: 19px;
                                    margin-left: -30px;
                                "
                            ></div>
                        </v-col>
                        <v-col cols="3" style="margin-left: -128px">พ.ศ.</v-col>
                        <v-col cols="1" style="margin-left: -100px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: 19px;
                                    margin-left: -30px;
                                "
                            ></div>
                        </v-col>
                    </v-row>
                    <v-row class="mt-4">
                        <v-col cols="2"> ชื่อที่ทำการไปรษณีย์ </v-col>
                        <v-col cols="4">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            >
                                {{ data_print.site_name || '\u00A0' }}
                            </div>
                        </v-col>
                        <v-col cols="2" style="margin-left: -25px">
                            ชื่อบริษัทที่ดำเนินการ
                        </v-col>
                        <v-col cols="4" style="margin-left: -5px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            >
                                {{
                                    data_print.project_name ==
                                    "Thailand POST_522565"
                                        ? "บริษัท โปรเฟสชั่นแนล เซอร์วิส แอนด์ โซลูชั่น จำกัด"
                                        : data_print.project_name ==
                                          "Thailand POST_202566"
                                        ? "บริษัท คอม เทรดดิ้ง จำกัด"
                                        : data_print.project_name ==
                                          "Thailand POST_792566"
                                        ? "บริษัท โปรเฟสชั่นแนล เซอร์วิส แอนด์ โซลูชั่น จำกัด"
                                        : data_print.project_name ==
                                          "Thailand POST_1292568"
                                        ? "กิจการค้าร่วม SPAC"
                                        : data_print.project_name ==
                                          "Thailand POST_932567"
                                        ? "กิจการค้าร่วม SPAC"
                                        : data_print.project_name ==
                                          "Thailand POST_942567"
                                        ? "กิจการค้าร่วม SPAC"
                                        : "บริษัท สุพรีม ดิสทิบิวชั่น (ไทยแลนด์) จำกัด"
                                }}
                            </div>
                        </v-col>
                    </v-row>
                    <v-row class="mt-4">
                        <v-col cols="2" style="margin-left: -35px">
                            เลขที่งาน
                        </v-col>
                        <v-col cols="1" style="margin-left: -33px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            >
                                {{ data_print.case_refer || '\u00A0' }}
                            </div>
                        </v-col>
                        <v-col cols="2" style="margin-left: -60px">
                            ชนิดอุปกรณ์</v-col
                        >
                        <v-col cols="2" style="margin-left: -35px">
                            <!-- <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            >
                                {{ data_print.product_description || '\u00A0' }}
                            </div> -->
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            >
                                {{ "" || '\u00A0' }}
                            </div>
                        </v-col>
                        <v-col cols="2" style="margin-left: -50px">
                            หมายเลขเครื่อง</v-col
                        >
                        <v-col cols="2" style="margin-left: -20px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            >
                                {{ data_print.product_serial || '\u00A0' }}
                            </div>
                        </v-col>
                        <v-col cols="2" style="margin-left: -50px">
                            เลขที่สัญญา</v-col
                        >
                        <v-col cols="2" style="margin-left: -30px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            >
                                {{
                                    data_print.project_name ==
                                    "Thailand Post (PO)"
                                        ? "สป(ส)/151/2559"
                                        : data_print.project_name ==
                                          "Thailand POST_702565"
                                        ? "สป(ส)70/2565"
                                        : data_print.project_name ==
                                          "Thailand POST (PO)_สป(ส)70/2565"
                                        ? "สป(ส)70/2565"
                                        : data_print.project_name ==
                                          "Thailand Post CAPOS"
                                        ? "สป(ส)82/2565"
                                        : data_print.project_name ==
                                          "Thailand POST_522565"
                                        ? "สป(ส)52/2565"
                                        : data_print.project_name ==
                                          "Thailand POST_202566"
                                        ? "สป(ส)20/2566"
                                        : data_print.project_name ==
                                          "Thailand POST_792566"
                                        ? "สป(ส)79/2566"
                                        : data_print.project_name ==
                                          "Thailand POST_1292568"
                                        ? "สป(ส)129/2568"
                                        : data_print.project_name ==
                                          "Thailand POST_932567"
                                        ? "สป(ส)93/2567"
                                        : data_print.project_name ==
                                          "Thailand POST_942567"
                                        ? "สป(ส)94/2567"
                                        : "สป(ส) 27/2564"
                                }}
                            </div>
                        </v-col>
                    </v-row>
                    <v-row class="mt-4">
                        <v-col cols="2" style="margin-left: -35px">
                            วันที่รับแจ้ง
                        </v-col>
                        <v-col cols="3" style="margin-left: -33px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            >
                                {{ data_print.date_create_thai || '\u00A0' }}
                            </div>
                        </v-col>
                        <v-col cols="2" style="margin-left: -80px"> เวลา</v-col>
                        <v-col cols="1" style="margin-left: -50px">
                            <!-- <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            >
                                {{ data_print.time_create_thai || '\u00A0'}}
                            </div> -->
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            >
                                {{ "" || '\u00A0'}}
                            </div>
                        </v-col>
                        <v-col cols="2" style="margin-left: -50px">
                            น. แล้วเสร็จวันที่*</v-col
                        >
                        <!-- <v-col cols="2" style="margin-left: -50px">
                             แล้วเสร็จวันที่</v-col
                        > -->
                        
                        <v-col cols="3" style="margin-left: -20px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            >
                                {{ data_print.date_onsite_thai || '\u00A0'  }}
                            </div>
                        </v-col>
                        <v-col cols="2" style="margin-left: -85px">เวลา</v-col>
                        <v-col cols="1" style="margin-left: -50px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            >
                                {{ data_print.time_onsite_thai  || '\u00A0' }}
                            </div>
                        </v-col>
                        <label style="margin-left: -10px">น.</label>
                    </v-row>
                    <!-- <v-row class="mt-4">
            <v-col cols="2" style="margin-left: -8px">รายละเอียดการซ่อม</v-col>
            <v-col cols="10" style="margin-left: -10px">
              <div
                style="
                  border-bottom: 1px dotted black;
                  margin-top: -5px;
                  margin-left: -30px;
                "
              >
                q
              </div>
            </v-col>
          </v-row> -->
                    <v-row class="mt-40" style="margin-top: 60px">
                        <v-col cols="2">ลงชื่อ*</v-col>
                        <v-col cols="2" style="margin-left: -50px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: 19px;
                                    margin-left: -30px;
                                "
                            ></div>
                        </v-col>
                        <v-col cols="2" style="margin-left: -40px"
                            >จนท.บริษัท ลงชื่อ*</v-col
                        >
                        <v-col cols="2" style="margin-left: -10px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: 19px;
                                    margin-left: -30px;
                                "
                            ></div>
                        </v-col>
                        <v-col cols="2" style="margin-left: -40px"
                            >จนท.ปณท. ลงชื่อ*</v-col
                        >
                        <v-col cols="2" style="margin-left: -10px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: 19px;
                                    margin-left: -30px;
                                "
                            ></div>
                        </v-col>
                        <v-col cols="2" style="margin-left: -45px"
                            >หน.ปณ./หนส./
                        </v-col>
                    </v-row>

                    <v-row class="mt-2">
                        <v-col cols="2"></v-col>

                        <v-col cols="2" style="margin-left: -35px">
                            <span style="margin-left: -35px">(</span>
                            <span style="margin-left: 180px">)</span>
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            ></div>
                        </v-col>
                        <v-col cols="1"></v-col>

                        <v-col cols="2" style="margin-left: 30px">
                            <span style="margin-left: -35px">(</span>
                            <span style="margin-left: 180px">)</span>
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            ></div>
                        </v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="2" style="margin-left: 5px">
                            <span style="margin-left: -35px">(</span>
                            <span style="margin-left: 180px">)</span>
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            ></div>
                        </v-col>
                        <v-col cols="2">ผู้ได้รับมอบหมาย</v-col>
                        <!-- <v-col cols="12">
              <span style="margin-left: 70px"
                >(....................................)</span
              >
              <span style="margin-left: 160px"
                >(.....................................)</span
              >
              <span style="margin-left: 140px"
                >(.....................................)</span
              >
              ผู้ได้รับมอบหมาย
            </v-col> -->
                        <!-- <v-col class="" cols="3"
              >(....................................)
            </v-col>
            <v-col cols="3">(.....................................)</v-col>
            <v-col cols="3">(.....................................) </v-col>
            <v-col cols="3">ผู้ได้รับมอบหมาย</v-col> -->
                    </v-row>
                    <v-row class="mt-2">
                        <v-col cols="4"></v-col>
                        <v-col cols="2" style="margin-left: -30px"
                            >เบอร์โทรติดต่อ</v-col
                        >
                        <v-col cols="1">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: 19px;
                                    margin-left: -50px;
                                "
                            ></div>
                        </v-col>
                        <v-col cols="4"
                            >.........../.............../...........
                        </v-col>
                    </v-row>
                    <v-row class="mt-4">
                        <v-col cols="6"
                            ><div class="mt-5">
                                <span
                                    >หมายเหตุ : ส่วนที่ 1
                                    บริษัทรวบรวมส่งคืนฝ่ำยปฏิบัติกำรและสนับสนุนด้ำนดิจิทัล</span
                                >
                                <br />
                                <span 
                                    >เลขที่งานบริษัท :
                                    {{ data_print.case_id }} -
                                    {{ data_sub.subcase }}</span
                                >
                            </div>
                        </v-col>
                        <v-col cols="6">
                            <div
                                align="center"
                                style="
                                    margin-left: 100px;
                                    width: 150px;
                                    height: 150px;
                                    border-radius: 50%;
                                    border: 1px solid black;
                                "
                            >
                                <br />
                                <span
                                    >ประทับตรา<br />ประจำวัน<br />ให้ชัดเจน*
                                </span>
                            </div>
                        </v-col>
                    </v-row>
                </div>
                <div>
                    <v-row>
                        <v-col cols="12"
                            ><v-icon size="20">mdi-content-cut</v-icon
                            >.......................................................................................................
                            ........................................................................................................
                            ..................................</v-col
                        >
                    </v-row>
                </div>
                <div id="bottom">
                    <v-row>
                        <v-col align="left" cols="4">
                            <span>ส่วนที่ 2 ใบงานการบำรุงรักษา</span></v-col
                        >
                        <v-col cols="4"></v-col>
                        <v-col align="right" cols="4">
                            <span>(ส่วนของที่ทำการไปรษณีย์)</span><br
                        /></v-col>
                    </v-row>
                    <v-row
                        ><img
                            style="
                                text-align: right;
                                width: 500px;
                                height: 75px;
                            "
                            src="../../../assets/nonhp/thaipost_logo.jpg"
                    /></v-row>
                    <v-row class="mt-4">
                        <v-col cols="3"></v-col>
                        <v-col cols="3">วันที่</v-col>
                        <v-col cols="1" style="margin-left: -100px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: 19px;
                                    margin-left: -30px;
                                "
                            ></div>
                        </v-col>
                        <v-col cols="3" style="margin-left: -128px"
                            >เดือน</v-col
                        >
                        <v-col cols="1" style="margin-left: -100px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: 19px;
                                    margin-left: -30px;
                                "
                            ></div>
                        </v-col>
                        <v-col cols="3" style="margin-left: -128px">พ.ศ.</v-col>
                        <v-col cols="1" style="margin-left: -100px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: 19px;
                                    margin-left: -30px;
                                "
                            ></div>
                        </v-col>
                    </v-row>
                    <v-row class="mt-4">
                        <v-col cols="2"> ชื่อที่ทำการไปรษณีย์ </v-col>
                        <v-col cols="4">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            >
                                {{ data_print.site_name  || '\u00A0' }}
                            </div>
                        </v-col>
                        <v-col cols="2" style="margin-left: -25px">
                            ชื่อบริษัทที่ดำเนินการ
                        </v-col>
                        <v-col cols="4" style="margin-left: -5px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            >
                                {{
                                    data_print.project_name ==
                                    "Thailand POST_522565"
                                        ? "บริษัท โปรเฟสชั่นแนล เซอร์วิส แอนด์ โซลูชั่น จำกัด"
                                        : data_print.project_name ==
                                          "Thailand POST_202566"
                                        ? "บริษัท คอม เทรดดิ้ง จำกัด"
                                        : data_print.project_name ==
                                          "Thailand POST_792566"
                                        ? "บริษัท โปรเฟสชั่นแนล เซอร์วิส แอนด์ โซลูชั่น จำกัด"
                                        : data_print.project_name ==
                                          "Thailand POST_1292568"
                                        ? "กิจการค้าร่วม SPAC"
                                        : data_print.project_name ==
                                          "Thailand POST_932567"
                                        ? "กิจการค้าร่วม SPAC"
                                        : data_print.project_name ==
                                          "Thailand POST_942567"
                                        ? "กิจการค้าร่วม SPAC"
                                        : "บริษัท สุพรีม ดิสทิบิวชั่น (ไทยแลนด์) จำกัด"
                                }}
                            </div>
                        </v-col>
                    </v-row>
                    <v-row class="mt-4">
                        <v-col cols="2" style="margin-left: -35px">
                            เลขที่งาน
                        </v-col>
                        <v-col cols="1" style="margin-left: -33px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            >
                                {{ data_print.case_refer || '\u00A0' }}
                            </div>
                        </v-col>
                        <v-col cols="2" style="margin-left: -60px">
                            ชนิดอุปกรณ์</v-col
                        >
                        <v-col cols="2" style="margin-left: -35px">
                            <!-- <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            >
                                {{ data_print.product_description || '\u00A0' }}
                            </div> -->
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            >
                                {{ "" || '\u00A0' }}
                            </div>
                        </v-col>
                        <v-col cols="2" style="margin-left: -50px">
                            หมายเลขเครื่อง</v-col
                        >
                        <v-col cols="2" style="margin-left: -20px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            >
                                {{ data_print.product_serial || '\u00A0' }}
                            </div>
                        </v-col>
                        <v-col cols="2" style="margin-left: -50px">
                            เลขที่สัญญา</v-col
                        >
                        <v-col cols="2" style="margin-left: -30px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            >
                                <!-- {{
                                    data_print.project_name ==
                                    "Thailand Post (PO)"
                                        ? "สป(ส)/151/2559"
                                        : "สป(ส) 27/2564"
                                }} -->
                                {{
                                    data_print.project_name ==
                                    "Thailand Post (PO)"
                                        ? "สป(ส)/151/2559"
                                        : data_print.project_name ==
                                          "Thailand POST_702565"
                                        ? "สป(ส)70/2565"
                                        : data_print.project_name ==
                                          "Thailand POST (PO)_สป(ส)70/2565"
                                        ? "สป(ส)70/2565"
                                        : data_print.project_name ==
                                          "Thailand Post CAPOS"
                                        ? "สป(ส)82/2565"
                                        : data_print.project_name ==
                                          "Thailand POST_522565"
                                        ? "สป(ส)52/2565"
                                        : data_print.project_name ==
                                          "Thailand POST_202566"
                                        ? "สป(ส)20/2566"
                                        : data_print.project_name ==
                                          "Thailand POST_792566"
                                        ? "สป(ส)79/2566"
                                        : data_print.project_name ==
                                          "Thailand POST_1292568"
                                        ? "สป(ส)129/2568"
                                        : data_print.project_name ==
                                          "Thailand POST_932567"
                                        ? "สป(ส)93/2567"
                                        : data_print.project_name ==
                                          "Thailand POST_942567"
                                        ? "สป(ส)94/2567"
                                        : "สป(ส) 27/2564"
                                }}
                            </div>
                        </v-col>
                    </v-row>
                    <v-row class="mt-4">
                        <v-col cols="2" style="margin-left: -35px">
                            วันที่รับแจ้ง
                        </v-col>
                        <v-col cols="3" style="margin-left: -33px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            >
                                {{ data_print.date_create_thai || '\u00A0' }}
                            </div>
                        </v-col>
                        <v-col cols="2" style="margin-left: -80px"> เวลา</v-col>
                        <v-col cols="1" style="margin-left: -50px">
                            <!-- <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            >
                                {{ data_print.time_create_thai || '\u00A0'}}
                            </div> -->
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            >
                                {{ "" || '\u00A0'}}
                            </div>
                        </v-col>
                        <v-col cols="2" style="margin-left: -50px">
                            น. แล้วเสร็จวันที่*</v-col
                        >
                        <!-- <v-col cols="2" style="margin-left: -50px">
                            แล้วเสร็จวันที่</v-col
                        > -->
                        <v-col cols="3" style="margin-left: -20px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            >
                                {{ data_print.date_onsite_thai  || '\u00A0' }}
                            </div>
                        </v-col>
                        <v-col cols="2" style="margin-left: -85px">เวลา</v-col>
                        <v-col cols="1" style="margin-left: -50px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            >
                                {{ data_print.time_onsite_thai || '\u00A0' }}
                            </div>
                        </v-col>
                        <label style="margin-left: -10px">น.</label>
                    </v-row>
                    <v-row class="mt-4">
                        <v-col cols="2" style="margin-left: -8px"
                            >รายละเอียดการซ่อม</v-col
                        >
                        <v-col cols="10" style="margin-left: -10px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: 19px;
                                    margin-left: -30px;
                                "
                            ></div>
                        </v-col>
                    </v-row>
                    <v-row class="mt-1">
                        <v-col cols="12" style="margin-left: -10px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: 19px;
                                    margin-left: -30px;
                                "
                            ></div>
                        </v-col>
                    </v-row>
                    <v-row class="mt-40" style="margin-top: 60px">
                        <v-col cols="2">ลงชื่อ*</v-col>
                        <v-col cols="2" style="margin-left: -50px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: 19px;
                                    margin-left: -30px;
                                "
                            ></div>
                        </v-col>
                        <v-col cols="2" style="margin-left: -40px"
                            >จนท.บริษัท ลงชื่อ*</v-col
                        >
                        <v-col cols="2" style="margin-left: -10px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: 19px;
                                    margin-left: -30px;
                                "
                            ></div>
                        </v-col>
                        <v-col cols="2" style="margin-left: -40px"
                            >จนท.ปณท. ลงชื่อ*</v-col
                        >
                        <v-col cols="2" style="margin-left: -10px">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: 19px;
                                    margin-left: -30px;
                                "
                            ></div>
                        </v-col>
                        <v-col cols="2" style="margin-left: -45px"
                            >หน.ปณ./หนส./
                        </v-col>
                    </v-row>

                    <v-row class="mt-2">
                        <v-col cols="2"></v-col>

                        <v-col cols="2" style="margin-left: -35px">
                            <span style="margin-left: -35px">(</span>
                            <span style="margin-left: 180px">)</span>
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            ></div>
                        </v-col>
                        <v-col cols="1"></v-col>

                        <v-col cols="2" style="margin-left: 30px">
                            <span style="margin-left: -35px">(</span>
                            <span style="margin-left: 180px">)</span>
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            ></div>
                        </v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="2" style="margin-left: 5px">
                            <span style="margin-left: -35px">(</span>
                            <span style="margin-left: 180px">)</span>
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: -5px;
                                    margin-left: -30px;
                                "
                            ></div>
                        </v-col>
                        <v-col cols="2">ผู้ได้รับมอบหมาย</v-col>
                        <!-- <v-col cols="12">
              <span style="margin-left: 70px"
                >(....................................)</span
              >
              <span style="margin-left: 160px"
                >(.....................................)</span
              >
              <span style="margin-left: 140px"
                >(.....................................)</span
              >
              ผู้ได้รับมอบหมาย
            </v-col> -->
                        <!-- <v-col class="" cols="3"
              >(....................................)
            </v-col>
            <v-col cols="3">(.....................................)</v-col>
            <v-col cols="3">(.....................................) </v-col>
            <v-col cols="3">ผู้ได้รับมอบหมาย</v-col> -->
                    </v-row>
                    <v-row class="mt-2">
                        <v-col cols="4"></v-col>
                        <v-col cols="2" style="margin-left: -30px"
                            >เบอร์โทรติดต่อ</v-col
                        >
                        <v-col cols="1">
                            <div
                                style="
                                    border-bottom: 1px dotted black;
                                    margin-top: 19px;
                                    margin-left: -50px;
                                "
                            ></div>
                        </v-col>
                        <v-col cols="4"
                            >.........../.............../...........
                        </v-col>
                    </v-row>
                    <v-row class="mt-4">
                        <v-col cols="6"
                            ><div class="mt-5">
                                <span
                                    >หมายเหตุ : ส่วนที่ 1
                                    บริษัทรวบรวมส่งคืนฝ่ำยปฏิบัติกำรและสนับสนุนด้ำนดิจิทัล</span
                                >
                                <br />
                                <span 
                                    >เลขที่งานบริษัท :
                                    {{ data_print.case_id }} -
                                    {{ data_sub.subcase }}</span
                                >
                            </div>
                        </v-col>
                        <v-col cols="6">
                            <div
                                align="center"
                                style="
                                    margin-left: 100px;
                                    width: 150px;
                                    height: 150px;
                                    border-radius: 50%;
                                    border: 1px solid black;
                                "
                            >
                                <br />
                                <span
                                    >ประทับตรา<br />ประจำวัน<br />ให้ชัดเจน*
                                </span>
                            </div>
                        </v-col>
                    </v-row>
                </div>
                <div>
                    <v-row>
                        <v-col cols="12"
                            ><v-icon size="20">mdi-content-cut</v-icon
                            >.......................................................................................................
                            ........................................................................................................
                            ..................................</v-col
                        >
                    </v-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"

import { mapState, mapMutations } from "vuex"
import VueHtmlToPaper from "vue-html-to-paper"

const options = {
    name: "_blank",
    specs: ["fullscreen=no", "titlebar=no", "scrollbars=no"],
    styles: [
        "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
        "https://unpkg.com/kidlat-css/css/kidlat.css",
    ],
}

export default {
    mounted() {
        this.getDetail()
    },
    ...mapMutations(["mutateMiniSidebar"]),
    methods: {
        print() {
            this.$htmlToPaper("printDiv")
        },
        async getDetail() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/casedetail/${this.$route.params.maincase_id}`
            try {
                const { data } = await axios.get(`${url}`, options)
                this.data_print = data
                this.data_print.subs.map((each) => {
                    if (each.subcase_id == this.$route.params.subcase_id) {
                        this.data_sub = each
                    }
                })
            } catch (error) {
                console.log(error)
            }
        },
    },
    data() {
        return {
            data_print: [],
            data_sub: [],
        }
    },
}
</script>
<style scoped>
.spacing-playground .v-select .v-input__prepend-outer,
.spacing-playground .v-select .v-input__append-outer {
    margin-top: 0.55rem;
    margin-right: 0.2rem;
}
body {
    margin: 0 !important;
}
</style>